export const refundMethodText = {
  store_credit: 'Crédito tienda',
  bank_transfer: 'Transferencia',
  original_payment_method: 'Método pago original',
  gift_card: 'Tarjeta regalo',
}

export const refundStatuses = {
  completed: 'completed',
}
